import { Link } from "react-router-dom";
import { AUTHOR } from "../seo/author";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" }) : "");

/** Signature auteur sous chaque guide (E-E-A-T) + JSON-LD Person. */
export function AuthorSignature({ guide }) {
  return (
    <aside className="mt-10 rounded-2xl border border-white/10 bg-white/[0.04] p-5 flex items-start gap-4" data-testid="guide-author">
      <div className="h-12 w-12 shrink-0 rounded-full bg-[#0b1a35] border border-brass/40 grid place-items-center text-brass display text-xl" aria-hidden="true">{AUTHOR.initial}</div>
      <div className="text-sm">
        <p className="text-white font-medium">Rédigé et relu par <Link to={`/auteur/${AUTHOR.slug}`} className="text-brass hover:underline" data-testid="guide-author-link">{AUTHOR.name}</Link></p>
        <p className="text-slate-400 mt-0.5">{AUTHOR.role}</p>
        {guide?.updated_at && <p className="text-xs text-slate-500 mt-2">Mis à jour le {fmt(guide.updated_at)}{guide.created_at && guide.created_at.slice(0, 10) !== guide.updated_at.slice(0, 10) ? ` · publié le ${fmt(guide.created_at)}` : ""}</p>}
      </div>
    </aside>
  );
}
